// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"l6-z"};